"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoothCard = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var image_1 = require("./styled/image");

var organizer_avatar_1 = require("./styled/organizer-avatar");

var BoothCard = function BoothCard(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      backgroundImage = _a.backgroundImage,
      logo = _a.logo,
      name = _a.name,
      about = _a.about;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'BoothCard',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(ui_flex_1.Flex, {
    className: rootClasses,
    level: "low",
    cornerRadius: "lg",
    border: "grey-200",
    flexDirection: "column"
  }, react_1.default.createElement(image_1.Image, {
    src: backgroundImage,
    alt: ""
  }), react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center",
    px: 2,
    mt: 2,
    mb: 1
  }, react_1.default.createElement(organizer_avatar_1.OrganizerAvatar, {
    src: logo,
    alt: ""
  }), react_1.default.createElement(ui_text_1.Text, {
    pattern: "bodyLargeMedium",
    element: "h2"
  }, name)), about && react_1.default.createElement(ui_text_1.Text, {
    pattern: "emphasis",
    element: "p",
    px: 2,
    pb: 2
  }, about));
};

var BoothCardWithSpace = (0, ui_helper_with_space_1.withSpace)(BoothCard);
exports.BoothCard = BoothCardWithSpace;